import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  width: 100vw;
  height: 100vh;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #282828;
`

export const SubContainer = styled.div`
  max-width: 724px;
`

export const Title = styled.div`
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.ORANGE};
`

export const Description = styled.div`
  width: 100%;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
  white-space: pre;
  padding: 18px 0px 70px 0px;
`

export const IconContainer = styled.div`
`